const porocol = window.location.protocol,
  esFing = window.location.href.includes("fing.edu.uy"),
  raiz = window.location.port
    ? // estoy en localhost/0.0.0.0/127.0.0.1
      // pero no puedo distinguir entre `yarn start` de react y
      // proto-produccion `py app`
      // PERO sus puertos son diferentes (80 vs 33507)
      // discrimino en base a ello
      window.location.hostname
    : esFing
    ? "www.fing.edu.uy/inco/proyectos/cinacina"
    : "cinacina.fic.edu.uy",
  base = "//" + raiz,
  httpPort =
    // si estamos en el puerto :3000 eso significa que nos está sirviendo
    // el servidor de yarn. entonces supongo que la api se encuentra levantada
    // en local en el puerto :8080
    window.location.port === "3000"
      ? ":8080"
      : // si no estamos conectados desde el 3000, pero desde algun puerto
      // (ejemplo, mediante un tunel ssh a boole)
      // entonces supongo que la api se encuentra accesible desde el mismo puerto
      window.location.port
      ? `:${window.location.port}`
      : // en caso contraro
        // (es decir, sin puerto)
        // entonces nos estamso conectando directo desde una pagina web
        // (eg, "http://cinacina.fic.edu.uy") 
        // y supongo que el puerto es el :80 (ie, decir el puerto vacio "")
        "",
  wsProto = porocol === "https:" ? "wss:" : "ws:",
  wsPort = esFing ? "" : ":5000"

export const config = {
  cli_build: "251014",
  base: porocol + base + httpPort,
  apiUrl: porocol + base + httpPort + "/api",
  imgUrl: porocol + base + httpPort + "/assets/img",
  // wsUrl: wsProto + base + wsPort,
  wsUrl: esFing ? wsProto + base + "/wss" : wsProto + base + wsPort,
  PRIVATE_MODE: false,
  errors: {
    404: "404: el recurso solicitado no existe",
  },
  default_limit: 500,
  base2: process.env.PUBLIC_URL,
}
